import React from 'react';
import PropTypes from 'prop-types';

export default function withLocalStorage(Component) {
  Component.contextTypes = Component.contextTypes || {};
  Component.contextTypes.localStorageHelper = PropTypes.object.isRequired;
  return Component;
}



// WEBPACK FOOTER //
// ./spa/Components/Context/withLocalStorage.jsx